export class ExportInfo {
    Id?: number;
    Name = '';
    Description?: string;
    Contents?: ExportContentType[];
    Backup?: boolean;
    CreatedAt?: string;
    ExportTypes?: string[];
    DefaultAction?: number;
    constructor(name: string, description: string) {
        this.Name = name;
        this.Description = description;
    }
}

export class ExportContentType {
    Id?: number;
    Type = '';
}

export class ImportInfo {
    Types?: string[];
    ExportTypes?: string[];
    DefaultAction?: number;
}